export default __webpack_public_path__ + "static/media/padlock-locked.inline.713a61ea.svg";